import { siteData, locations } from '../../data/mock';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { Mail, Phone, MapPin } from 'lucide-react';

export const CTASection = () => {
  const [ref, isVisible] = useScrollAnimation();

  return (
    <section
      id="contact"
      className="bg-[#0A0A0A] py-20 lg:py-28 border-t border-white/[0.03]"
    >
      <div
        ref={ref}
        className={`max-w-[1600px] mx-auto px-6 lg:px-16 transition-all duration-700 ${
          isVisible
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-start">
          {/* Left — CTA Text */}
          <div>
            <p className="text-[#C4A265] tracking-[0.4em] uppercase text-[11px] mb-4">
              Let&rsquo;s Talk
            </p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.5rem] text-[#F5F1EC] leading-[1.05] mb-6">
              <span className="font-light">Every</span>{' '}
              <span className="italic text-[#C4A265]">Detail</span>
              <br />
              <span className="font-light">Matters.</span>
            </h2>
            <p className="text-[#8A8580] text-base leading-relaxed max-w-md mb-10">
              Ready to start your project? Whether you're on the East Coast,
              West Coast, or in Florida — we'd love to hear from you.
            </p>

            {/* Contact Info */}
            <div className="space-y-5">
              <a
                href={`mailto:${siteData.email}`}
                className="flex items-center gap-3 text-[#F5F1EC] hover:text-[#C4A265] transition-colors duration-300 group"
              >
                <div className="w-10 h-10 flex items-center justify-center border border-white/[0.08] group-hover:border-[#C4A265]/30 transition-colors duration-300">
                  <Mail size={16} className="text-[#C4A265]" />
                </div>
                <span className="text-sm tracking-wide">{siteData.email}</span>
              </a>

              <a
                href={`tel:${siteData.phone}`}
                className="flex items-center gap-3 text-[#F5F1EC] hover:text-[#C4A265] transition-colors duration-300 group"
              >
                <div className="w-10 h-10 flex items-center justify-center border border-white/[0.08] group-hover:border-[#C4A265]/30 transition-colors duration-300">
                  <Phone size={16} className="text-[#C4A265]" />
                </div>
                <span className="text-sm tracking-wide">{siteData.phone}</span>
              </a>
            </div>
          </div>

          {/* Right — Showroom Locations */}
          <div>
            <p className="text-[#C4A265] tracking-[0.4em] uppercase text-[11px] mb-8">
              Showrooms
            </p>
            <div className="space-y-8">
              {locations.map((loc) => (
                <div
                  key={loc.name}
                  className="group flex items-start gap-4 pb-8 border-b border-white/[0.04] last:border-none last:pb-0"
                >
                  <div className="w-10 h-10 flex items-center justify-center border border-white/[0.08] shrink-0 mt-0.5">
                    <MapPin size={16} className="text-[#C4A265]" />
                  </div>
                  <div>
                    <h4 className="font-serif text-xl text-[#F5F1EC] italic mb-1">
                      {loc.name}
                    </h4>
                    <p className="text-[#8A8580] text-sm">{loc.address}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Markets served */}
            <div className="mt-12 pt-8 border-t border-white/[0.04]">
              <p className="text-[#C4A265] tracking-[0.4em] uppercase text-[10px] mb-4">
                Markets Served
              </p>
              <div className="flex flex-wrap gap-3">
                {[
                  'East Coast',
                  'West Coast',
                  'Florida',
                  'Hurricane Rated',
                ].map((tag) => (
                  <span
                    key={tag}
                    className={`text-[10px] tracking-[0.2em] uppercase px-3.5 py-1.5 transition-colors duration-300 ${
                      tag === 'Hurricane Rated'
                        ? 'bg-[#C4A265] text-[#0A0A0A] font-medium'
                        : 'border border-white/[0.08] text-[#8A8580]'
                    }`}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
